class Loading {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    scrollBan();
    const loadingBar = document.querySelector('.js-loading-bar');
    const loadingWrap = document.querySelector('.js-loading');
    const tl = gsap.timeline();
    tl
      .to(loadingBar, {
        width: '102%',
        duration: 3,
        ease: "power3.inOut",
        onComplete: () => {
          scrollBan();
        }
      })
      .to(loadingWrap, {
        opacity: 0,
        duration: 1,
        onComplete: () => {
          loadingWrap.remove();
        }
      })
  }
}